import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=4b6462a0&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6462a0",
  null
  
)

export default component.exports